import React from "react";

const ClickableBadge = () => {
	// Container for the entire badge
	const containerStyle = {
		position: "relative",
		width: "250px",
		height: "120px",
		display: "inline-block",
	};

	// Style for the absolutely positioned images (first & third)
	const absoluteImgStyle = {
		width: "auto",
		position: "absolute",
		top: 0,
		left: 0,
		WebkitTouchCallout: "none",
		border: "none",
		cursor: "pointer",
	};

	// Style for the relatively positioned image (second one)
	const relativeImgStyle = {
		width: "auto",
		backgroundRepeat: "no-repeat",
		padding: "0px",
		maxWidth: "none",
		backgroundImage:
			"url(https://cdn.yoshki.com/bics/validation/250/0/=validate.png?a=121*01$01090=9@55013@12@1240=30=60=4@5501$012@=8)",
		position: "relative",
		top: 0,
		left: 0,
		WebkitTouchCallout: "none",
		border: "none",
		cursor: "pointer",
	};

	// Invisible iframe overlay styles with pointerEvents explicitly enabled
	const iframeStyle = {
		position: "absolute",
		top: 0,
		left: 0,
		width: "250px",
		height: "120px",
		opacity: 0, // Invisible but will still capture clicks
		border: "none",
		zIndex: 100,
		pointerEvents: "auto", // Ensures the iframe receives pointer events
	};

	// Image sources (as provided in the original badge)
	const src1 = "https://cdn.yoshki.com/bics/validation/250/0/_validate.png";
	const src2 =
		"https://cdn.yoshki.com/bics/validation/250/0/-validate.png?a=121*01$01090=9@55013@12@1240=30=60=4@5501$012@8";
	const src3 = "https://cdn.yoshki.com/bics/validation/250/0/_validate.png";

	// The URL for the invisible iframe overlay (use the exact URL required)
	const iframeSrc = "https://cdn.yoshki.com/badge-bics.html";

	// Optional error handler for images
	const handleImgError = (e) => {
		e.target.onerror = null;
		e.target.src =
			"https://cdn.yoshki.com/bics/validation/250/0/error-validate.png";
	};

	return (
		<div style={containerStyle}>
			{/* First image (absolute positioned) */}
			<img
				src={src1}
				alt="Verify bics Membership"
				style={absoluteImgStyle}
				onError={handleImgError}
			/>
			{/* Second image (relative positioned with background image effect) */}
			<img
				src={src2}
				alt="Verify bics Membership"
				style={relativeImgStyle}
				onError={handleImgError}
			/>
			{/* Third image (absolute positioned) */}
			<img
				src={src3}
				alt="Verify bics Membership"
				style={absoluteImgStyle}
				onError={handleImgError}
			/>
			{/* Invisible iframe overlay */}
			<iframe
				referrerpolicy="origin"
				title="Badge Overlay"
				src={iframeSrc}
				style={iframeStyle}
				scrolling="no"
				frameBorder="0"
				allowTransparency="true"
			></iframe>
		</div>
	);
};

export default ClickableBadge;
